import { useState, useEffect } from 'react'; 
import { Sheet } from "react-modal-sheet";
import TrashIcon from "@/components/icons/TrashIcon";
import { useThemeMode } from "@/contexts/ThemeContext"; 

const DeleteAccountSheet = ({ open, onClose, onConfirm, loading = false }) => {
     const { isDarkMode } = useThemeMode(); 

     return (
          <Sheet isOpen={open} onClose={onClose} detent="content-height">
               <Sheet.Container
                    className={"sheet-bg"}
                    style={{
                         borderTopLeftRadius: "16px",
                         borderTopRightRadius: "16px",
                         maxWidth: "auto",
                         margin: "0 auto",
                         transform: open ? "translateY(0)" : "translateY(100%)",
                         opacity: open ? 1 : 0,
                         transition: "transform 0.4s ease, opacity 0.3s ease",
                         backgroundColor: isDarkMode ? "#0d1015": '#fff',  
                         color: isDarkMode ? "#fff" : "#000",
                    }}
               >
                    <Sheet.Header />
                    <Sheet.Content style={{ padding: "24px", textAlign: "center" }}>
                         <div style={{ fontSize: "48px", color: "#dc3545", marginBottom: "16px" }}>
                              <TrashIcon />
                         </div>
                         <p style={{ fontSize: "20px", fontWeight: "600" }}>
                              Ștergere cont
                         </p>
                         <p style={{ fontSize: "16px", margin: "16px 0 32px" }}>
                              Ești sigur că vrei să ștergi contul? Această acțiune este ireversibilă.
                         </p>

                         <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                              <button
                                   onClick={onClose}
                                   style={{
                                        padding: "12px 24px",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd",
                                        background: "transparent",
                                        
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                   }}
                                   
                              >
                                   Anulează
                              </button>
                              <button
                                   onClick={onConfirm}
                                   disabled={loading}
                                   style={{
                                        padding: "12px 24px",
                                        borderRadius: "8px",
                                        border: "none",
                                        background: "#dc3545",
                                        color: "white",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        opacity: loading ? 0.7 : 1,
                                   }}
                              >
                                   {loading ? "Se șterge..." : "Confirmă"}
                              </button>
                         </div>
                    </Sheet.Content>
               </Sheet.Container>
               <Sheet.Backdrop />
          </Sheet>
     );
};

export default DeleteAccountSheet;